<div class="add-statement">
  <!-- Start Add Modal Header -->
  <div class="modal-header-full mb-0">
    <div class="ui-g-12 flex-between-center py-0">
      <div class="flex-start-center width-100p">
        <i class="far fa-file-invoice-dollar header-icon"></i>
        <div class="modal-description-full width-100p p-relative">
          <span class="font-18 font-700">Bulk payment</span>
        </div>
        <i id="statement-close-dialog" class="far fa-times pointer dialog-close" (click)="closeDialog()"></i>
      </div>
    </div>
  </div>
  <!-- End Add Modal Header -->

  <!-- Statement body -->
  <div class="ui-g statement-body pt-0 pb-0 border-bottom-light">
    <div class="ui-g-12 inputs-column-spacing statement-inner-body">
      <!-- Start Left panel -->
      <div class="ui-g-9 p-zero left-box">
        <div class="row mb-3">
          <!-- Supplier -->
          <div class="col-12">
            <label class="font-14 font-600 mb-4px">Supplier</label>
            <app-input placeholder="" theme="border" [value]="supplier?.name" disabled> </app-input>
          </div>
        </div>

        <div class="row">
          <div class="col-6">
            <div class="row align-items-center">
              <!-- Payment type* -->
              <div class="col-6">
                <label class="font-14 font-600 mb-4px">Payment type*</label>
                <app-dropdown
                  placeholder="Payment type"
                  theme="border"
                  position="bottom"
                  field="label"
                  scrollHeight="200px"
                  styleClassSelectedView="payment-method-dropdown"
                  [fontSize]="12"
                  [setPositionDynamically]="false"
                  [options]="paymentTypes"
                  [isDropdownIconVisible]="true"
                  [value]="selectedPaymentType"
                  (appSelect)="activateMethodCard($event, true)"
                >
                </app-dropdown>
              </div>

              <!-- Payment method* -->
              <div class="col-6">
                <label class="font-14 font-600 mb-4px">Payment method*</label>
                <app-dropdown
                  placeholder="Payment method"
                  theme="border"
                  position="bottom"
                  field="name"
                  scrollHeight="200px"
                  styleClassSelectedView="payment-method-dropdown"
                  [fontSize]="12"
                  [setPositionDynamically]="false"
                  [options]="paymentMethods"
                  [isDropdownIconVisible]="true"
                  [value]="selectedPaymentMethod"
                  (appSelect)="onCardMethodSelect($event)"
                >
                </app-dropdown>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="row align-items-center justify-content-end">
              <!-- Date -->
              <div class="col-6">
                <label class="font-12 font-600 mb-4px">Date</label>
                <div class="calendar-input flex-between-center payment-date pointer">
                    <p-calendar
                      id="payment-date"
                      placeholder="Date"
                      styleClass="payment-pointer"
                      [(ngModel)]="payment.paymentDate"
                      [readonlyInput]="true"
                      [minDate]="payment?.createdAt"
                      [maxDate]="maxDateRange"
                      dateFormat="M d, yy"
                      (onSelect)="onDateTimeChange($event)"
                      #paymentDateTimeEl
                      styleClass="prime-calender"
                    ></p-calendar>
                    <i class="fal fa-calendar" (click)="paymentDateTimeEl.showOverlay()"></i>
                  </div>
              </div>
              <!-- Time -->
              <div class="col-6">
                <label class="font-12 font-600 mb-4px">Time*</label>
                <div>
                  <kendo-timepicker class="w-100" [(value)]="payment.paymentTime" [formatPlaceholder]="{ hour: 'hh', minute: 'mm' }"> </kendo-timepicker>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="payment-completed">
          <!-- Credit card no & security code -->
          <div
            *ngIf="
              (activePayment.value === 'card' && !isPaymentOnline) ||
              afterPayrixPayment ||
              afterSwipePayment ||
              (activePayment.value === 'card' && paymentId) ||
              (activePayment.value === 'card' && !isPayrixConnected)
            "
            class="ui-g-12 p-0"
          >
            <div class="ui-g-6">
              <label class="font-12 font-600 mb-4px">Last 4 digits*</label>
              <app-input
                type="text"
                mask="9999"
                theme="border"
                placeholder=""
                class="font-13"
                id="payment-card-last-4"
                [hasHoverBorderBottom]="false"
                [disabled]="disabled || afterPayrixPayment || afterSwipePayment"
                [hasHoverEffect]="false"
                (appChange)="handleChange($event, 'card4Digits')"
                [value]="payment.card4Digits"
              >
              </app-input>
            </div>
            <div class="ui-g-6">
              <label class="font-12 font-600 mb-4px">Confirmation no.*</label>
              <app-input
                id="payment-card-conf-no"
                type="text"
                theme="border"
                placeholder=""
                mask="0*"
                [patterns]="confirmCardPattern"
                class="font-13"
                [hasHoverBorderBottom]="false"
                [disabled]="disabled || afterPayrixPayment"
                [hasHoverEffect]="false"
                (appChange)="handleChange($event, 'cardConfNo')"
                [value]="payment.cardConfNo"
              >
              </app-input>
            </div>
          </div>
          <!-- Credit card no & security code -->
        </div>
        <!-- Payment method end -->

        <!-- Check No -->
        <div class="ui-g-12" *ngIf="activePayment.value === 'cheque'">
          <label class="font-12 font-600 mb-4px">{{ dataService.checkTxt }} number*</label>
          <app-input
            id="payment-cheque-no"
            type="text"
            theme="border"
            mask="0*"
            placeholder="0"
            class="font-13"
            [hasHoverBorderBottom]="false"
            [disabled]="disabled"
            [value]="payment.checkNo"
            [hasHoverEffect]="false"
            (appChange)="handleChange($event, 'checkNo')"
          >
          </app-input>
        </div>

        <div class="row align-items-center mb-3">
          <div class="col-9">
            <span class="font-14 font-bold font-secondary-700">Select orders</span>
          </div>
          <div class="col-3 pr-2">
            <app-list-filter type="parts" [options]="filterOptions" (filterChange)="filterChange($event)"> </app-list-filter>
          </div>
        </div>

        <!-- Supplier list table -->
        <div class="ui-g-12 p-0 bulk-supplier-table">
          <p-table class="statement-list" #dt sortField="code" [columns]="cols" [sortOrder]="-1"  [customSort]="true"
            [scrollable]="true" [value]="purchaseOrder" [lazy]="true" [sortOrder]="1" (onLazyLoad)="customSort($event)">
            <ng-template pTemplate="header" let-columns>
              <tr class="statement-row-header">
                <th pSortableColumn="checkbox" class="statement-checkbox pl-7p p-0">
                  <app-checkbox inputId="invoice-0" [binary]="false" [checkState]="tableCheckState" [greenCheckbox]="true" (appChange)="handleAllListSelect($event)"> </app-checkbox>
                </th>

                <th pSortableColumn="code" class="purchase-order text-nowrap" (click)="showIcon('code')" >
                  PO#
                  <p-sortIcon *ngIf="headerColumns['code']" [field]="'code'">
                  </p-sortIcon>
                </th>

                <th pSortableColumn="payableStatus" class="vehicle text-nowrap" (click)="showIcon('payableStatus')">Payable status
                  <p-sortIcon *ngIf="headerColumns['payableStatus']" [field]="'payableStatus'">
                  </p-sortIcon>
                </th>

                <th pSortableColumn="dueDate" class="invoice-date text-nowrap" (click)="showIcon('dueDate')">Due date
                  <p-sortIcon *ngIf="headerColumns['dueDate']" [field]="'dueDate'">
                  </p-sortIcon>
                </th>

                <th pSortableColumn="totalAmount" class="payment-status text-nowrap" (click)="showIcon('totalAmount')">Total order value
                  <p-sortIcon *ngIf="headerColumns['totalAmount']" [field]="'totalAmount'">
                  </p-sortIcon>
                </th>

                <th pSortableColumn="totalUnpaid" class="total-value text-nowrap" (click)="showIcon('totalUnpaid')">Balance due
                  <p-sortIcon *ngIf="headerColumns['totalUnpaid']" [field]="'totalUnpaid'">
                  </p-sortIcon>
                </th>

                <th pSortableColumn="totalUnpaidPayment" class="amount-remaning text-nowrap" (click)="showIcon('totalUnpaidPayment')">Payment amount
                  <p-sortIcon *ngIf="headerColumns['totalUnpaidPayment']" [field]="'totalUnpaidPayment'">
                  </p-sortIcon>
                </th>
                <!--
                <th *ngIf="showMultipleQBO" pSortableColumn="qboStatus" class="qbo-status text-nowrap">
                  Sync status
                </th> -->
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowData let-columns="columns">
              <tr class="statement-grid-row">
                <td *ngFor="let col of columns" [ngClass]="col.className" class="">
                  <div *ngIf="col.field === 'checkbox'" class="ml-m-5">
                    <div class="custom-checkbox-green pl-7p">
                      <app-checkbox [greenCheckbox]="true" [isChecked]="!!selectedItems[rowData?.sourceId]" (appChange)="handleItemSelect(rowData, $event)">
                      </app-checkbox>
                    </div>
                  </div>

                  <div *ngIf="col.field === 'code'" class="font-color width-100p flex-column">
                    <span class="font-13 font-secondary-900 m-0 flex-between-center pointer hover-underline" (click)="handleOpenPO( rowData)">
                      {{ rowData[col.field] }}
                    </span>
                  </div>

                  <div *ngIf="col.field === 'payableStatus'" class="flex-column">
                    <span class="text-truncate m-0">{{ rowData[col.field] }}</span>
                  </div>

                  <div class="width-100p" *ngIf="col.field === 'dueDate'">
                    <div class="flex-start-center">
                      <span class="text-nowrap">{{ rowData[col.field] | date : 'MMM d, yyyy' }}</span>
                    </div>
                  </div>

                  <div class="width-100p" *ngIf="col.field === 'totalAmount'">
                    <div>
                      <span class="font-13 font-secondary-900">
                        {{ rowData[col.field] || 0 | currency : usd }}
                      </span>
                    </div>
                  </div>

                  <div class="width-100p flex-column" *ngIf="col.field === 'totalUnpaid'">
                    <span class="text-truncate m-0">
                      {{ rowData[col.field] || 0 | currency : usd }}
                    </span>
                  </div>

                  <div class="width-100p" *ngIf="col.field === 'totalUnpaidPayment'">
                      <span class="flex-start-center pl-2 position-relative payment-mount-input">
                        <app-input class="" theme="light" [allowDecimal]="true"
                          placeholder="Payment amount"  [fontSize]="13" [disabled]="!selectedItems[rowData?.sourceId]"
                          [value]="(selectedItems[rowData?.sourceId] ? ((focus.paymentAmount ? rowData?.totalUnpaidPayment : rowData?.totalUnpaidPayment | currency : usd)) : ('0' | currency : usd))"
                          (appBlur)="handleBlur('paymentAmount', rowData._id)"
                          (appFocus)="focusInput('paymentAmount', rowData._id)"
                          (appChange)="handleTotalAmount(rowData, $event)">
                        </app-input>
                      </span>
                </div>
                </td>
              </tr>
            </ng-template>
          </p-table>

          <div class="ui-g-12" class="total-amount-row" *ngIf="!noRecFound">
            <div class="width-74p"></div>
            <div class="width-11p">
              <span class="font-14 font-600 font-secondary-700">Amount paid:</span>
            </div>
            <div class="width-14p">
              <span class="font-14 font-600 font-secondary-700">{{supplierTotal?.totalPaymnetAmount || 0 | currency : usd }}</span>
            </div>
          </div>

          <div *ngIf="!isItemLoading && noRecFound" class="mt-4 width-100p ui-g-12 text-center not-found">
            <span class="font-gray-35 font-12 mt-2">No data</span>
          </div>

          <div class="flex-center-center mt-1 width-100p mb-1" *ngIf="isItemLoading">
            <span class="pr-2">Loading</span>
            <i class="fal fa-spinner rotate"></i>
          </div>
        </div>

        <div class="ui-g-12">
          <label class="font-14 font-600 mb-4px">Notes</label>
          <app-textarea theme="border" name="notes"
          placeholder="Notes" rows="1" [value]="payment.notes"
          [fontSize]="14"  (appChange)="handleChangeNotes($event, 'notes')">
        </app-textarea>
        </div>
      </div>

      <!-- Start Right Panel -->
      <div class="ui-g-3 p-zero right-box">
        <div class="ui-g-12 p-0 mb-2">
          <!-- No of invoices -->
          <div class="label-row mb-1">
            <div class="label-heading font-bold">Paymnet summary</div>
            <div class="label-value float-right font-700">
              <!-- {{statementTotal.count}} -->
            </div>
          </div>

          <!-- No. of orders -->
          <div class="label-row">
            <div class="label-heading">No. of orders</div>
            <div class="label-value float-right">
              {{supplierTotal?.ordersCount || 0}}
            </div>
          </div>

          <!--Total balance due -->
          <div class="label-row">
            <div class="label-heading">Total balance due</div>
            <div class="label-value float-right">
              {{supplierTotal.totalBalanceDue | currency: usd}}
            </div>
          </div>

          <!-- Total payment amount  -->
          <div class="label-row">
            <div class="label-heading">Total payment amount</div>
            <div class="label-value float-right">
              {{supplierTotal?.totalPaymnetAmount || 0 | currency : usd }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Statement footer -->
  <div class="ui-g-12 flex-between-center dialog-footer statement-footer">
    <div class="part-add-dialog-footer text-right width-100p">
      <div>
        <button class="btn btn-border pointer btn-submit mr-2 btn-width" (click)="closeDialog()">Cancel</button>
        <button class="btn btn-primary pointer btn-submit btn-width"  [disabled]="isValid" (click)="handleSubmitPayment()">
          <span [ngClass]="{ 'pr-2': isProcessing }">Save</span>
          <i *ngIf="isProcessing" class="far fa-spinner rotate"></i>
        </button>
      </div>
    </div>
  </div>
  <!-- End Statement  Footer -->
</div>
